import React, { useState, useEffect } from "react";
import "./MaquettesLayout.css";
import readmeContent from "./README_CONTENT";

const MaquettesLayout = () => {
  const [currentMaquette, setCurrentMaquette] = useState("inscription-simple");
  const [readmeHtml, setReadmeHtml] = useState("");

  const maquettes = [
    {
      id: "inscription-simple",
      title: "01 - Inscription EP (Cas Simple)",
      file: "01-bis-inscription-ep-simple.html",
      section: "inscription",
    },
    {
      id: "inscription-complexe",
      title: "01 - Inscription EP (Cas Complexe)",
      file: "01-ter-inscription-ep-complexe.html",
      section: "inscription",
    },
    {
      id: "liste-session",
      title: "02 - Liste Session EP",
      file: "02-liste-session-ep.html",
      section: "liste-session",
    },
    {
      id: "formulaire-decision",
      title: "03 - Formulaire Décision",
      file: "03-formulaire-decision-ep.html",
      section: "formulaire-decision",
    },
    {
      id: "validation-directeur",
      title: "04 - Validation Directeur",
      file: "04-validation-directeur.html",
      section: "validation-directeur",
    },
  ];

  useEffect(() => {
    // Convertir le README markdown en HTML (simplifié)
    setReadmeHtml(readmeContent);

    // Scroll vers la section correspondante
    setTimeout(() => {
      const maquette = maquettes.find((m) => m.id === currentMaquette);
      const sectionId = `readme-${maquette?.section}`;
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMaquette]);

  const getMaquetteUrl = (file) => {
    return `/maquettes/${file}`;
  };

  return (
    <div className="maquettes-container">
      {/* Colonne 1 : Menu de navigation */}
      <div className="maquettes-sidebar">
        <div className="maquettes-sidebar-header">
          <h2>📐 Maquettes EP</h2>
          <p className="subtitle">Refactoring Loi Plein Emploi</p>
        </div>
        <nav className="maquettes-nav">
          {maquettes.map((maquette) => (
            <button
              key={maquette.id}
              className={`maquette-nav-item ${
                currentMaquette === maquette.id ? "active" : ""
              }`}
              onClick={() => setCurrentMaquette(maquette.id)}
            >
              <span className="nav-icon">📄</span>
              <span className="nav-text">{maquette.title}</span>
            </button>
          ))}
        </nav>
        <div className="maquettes-sidebar-footer">
          <p>
            💡 Utilisez les boutons ci-dessus pour naviguer entre les maquettes
          </p>
        </div>
      </div>

      {/* Colonne 2 : Maquette consultée (iframe isolé) */}
      <div className="maquettes-content">
        <div className="maquettes-content-header">
          <h3>{maquettes.find((m) => m.id === currentMaquette)?.title}</h3>
          <span className="badge">Maquette interactive</span>
        </div>
        <div className="maquettes-iframe-container">
          <iframe
            key={currentMaquette}
            src={getMaquetteUrl(
              maquettes.find((m) => m.id === currentMaquette)?.file
            )}
            title={maquettes.find((m) => m.id === currentMaquette)?.title}
            className="maquettes-iframe"
            sandbox="allow-scripts allow-same-origin"
          />
        </div>
      </div>

      {/* Colonne 3 : Documentation README */}
      <div className="maquettes-readme">
        <div className="maquettes-readme-header">
          <h3>📖 Documentation</h3>
        </div>
        <div
          className="maquettes-readme-content"
          dangerouslySetInnerHTML={{ __html: readmeHtml }}
        />
      </div>
    </div>
  );
};

export default MaquettesLayout;
